import Dexie from 'dexie'
export const db = new Dexie('Urepo_Front');

db.version(1).stores({
  // サマリ用ストア（主キー：from,to,store_id,type),valuesの中は配列で[name, self, all, high, low]
  summary: '&[from+to+store_id+type], *values, frame_status, timestamp',
  // グラフ用ストア（主キー：from,to,store_id,type),valuesの中は配列で[name, self, all, high, low]
  graph: '&[from+to+store_id+type], *values, frame_status, timestamp',
})
